import React from "react";
import "./App.css";
import AppRoutes from "./Routes";

const App: React.FC = () => {
  return <AppRoutes />;
};
export default App;
